import { dayjs } from '@/helpers/i18n'

// Format date filter (exported for app.config.globalProperties.$filters registration)
export default function formatDate(date) {
  return date ? dayjs(date).format('L') : ''
}
